import { briefingTeamUpdatesAPI } from "components/Apis/Briefing";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const TransferAssignmentsBoard = ({ }) => {
    const [transferAssignments, setTransferAssignments] = useState(null);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);


    useEffect(() => {
        if (!(briefing == "Old Briefings")) {
            (async () => {
                const data = await briefingTeamUpdatesAPI.getTransferAssignments();
                setTransferAssignments(data.data);
            })();
        }
        else {
            setTransferAssignments(null);
        }

    }, [startDate, endDate, searchTerm, briefing]);


    return (
        <>
            {
                transferAssignments && transferAssignments.length > 0 && (
                    <>
                        <p className="pop-badge">Northbound Transfer Assignments:</p>
                        <table className="briefing-table sub-section-table">
                            <thead>
                                <tr>
                                    <th>Pro #</th>
                                    <th>Vehicle Size</th>
                                    <th>Deliver To</th>
                                    <th>Delivery Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transferAssignments ? (
                                    transferAssignments.map((order, index) => (
                                        <tr key={index}>
                                            <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                            <td>{order.vehicle_size}</td>
                                            <td>{order.deliver_to}</td>
                                            <td>{order.delivery_date}</td>
                                            <td>
                                                <>{order.mx_status}</>
                                                {/* <ProgressBar
                                                    now={statusObjNB[order.mx_status]}
                                                    variant="success"
                                                    label={order.mx_status}
                                                /> */}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No transfer assignments found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <hr />
                    </>
                )
            }
        </>
    );
};

export default TransferAssignmentsBoard;